module.exports = __webpack_public_path__ + "static/nomadyoga-aae17cd5a28a686aafa534a13c714354.jpg";